
import Navbar from './Navbar/Navbar'
import Footer from './Footer'
import { Toast, ToastContainer } from './Toast';
import VerificationNotice from './VerificationNotice';
import { useEffect, useState } from 'react';
import { PageProvider } from "../contexts/PageContext";
import { checkLoginStatus, getUserData } from '../api/authService';
import { postComment } from '../api/adminService';


function Layout(props) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [user, setUser] = useState([]);

  useEffect(() => {
    const fetchUserData = async () => {
      const loggedIn = await checkLoginStatus();
      if (!loggedIn) {
        return;
      }
      try {
        const userData = await getUserData();
        if (!userData) {
          return;
        }
        setUser(userData);
      } catch (error) {
        console.log('Error fetching user:', error);
      }
    };

    fetchUserData();
  }, [])

  useEffect(() => {
    const checkPending = async () => {
      const pending = localStorage.getItem("pendingTestimonial");
      if (pending && user && user.id) {
        localStorage.removeItem("pendingTestimonial"); // remove first to avoid double submit
        Toast.info("Sharing Your Testimony");

        const parsed = JSON.parse(pending);
        try {
          const { success, message } = await postComment(parsed, user);
          if (!success) {
            Toast.warning(message || "Failed To Share Testimony");
            // restore pending if failed
            localStorage.setItem("pendingTestimonial", JSON.stringify(parsed));
          } else {
            // Toast.success("Testimony shared successfully!");
            handleTestimoneyShared()
          }
        } catch (error) {
          Toast.error(error.message || "Error submitting testimony");
          // restore pending if failed
          localStorage.setItem("pendingTestimonial", JSON.stringify(parsed));
        }
      }
    };

    checkPending();
  }, [user]);

  const handleTestimoneyShared = async () => {
    Toast.callBack.success(
      "Your testimony has been shared successfully! Would you like to view it now on the Testimonials page?",
      {
        onConfirm: async () => {
          window.location.href = "/testimonials";
        },
        onCancel: () => {
          // user stays on current page
        }
      }
    );
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile ? (
    <Layout_desktop props={props} />
  ) : (
    <Layout_desktop props={props} />
  );
}


function Layout_desktop({ props }) {
  return (
    <>
      <VerificationNotice />
      <div className="min-h-screen flex flex-col bg-white">
        {props.currentPageSlug !== "admin" && <Navbar currentPageSlug={props.currentPageSlug} />}
        <main className="flex-grow">
          <PageProvider currentPageSlug={props.currentPageSlug}>
            {props.children}
          </PageProvider>
        </main>
        {props.currentPageSlug !== "admin" && <Footer />}
        <ToastContainer theme="dark" pauseOnHover newestOnTop pauseOnFocusLoss />
      </div>
    </>
  );
}

function Layout_mobile({ props }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isScrolled2, setIsScrolled2] = useState(false);

  // useEffect(() => {
  //   const handleScroll = () => {
  //     setIsScrolled(window.scrollY > 100);
  //     setIsScrolled2(window.scrollY > 200);
  //   };

  //   window.addEventListener('scroll', handleScroll);
  //   return () => window.removeEventListener('scroll', handleScroll);
  // }, []);

  useEffect(() => {
    const scrollContainer = document.getElementById('TSO-scroll-container')
    const handleScroll = () => {
      if (scrollContainer) {
        setIsScrolled(scrollContainer.scrollTop > 100);
        setIsScrolled2(scrollContainer.scrollTop > 300);
      }
    };

    scrollContainer?.addEventListener('scroll', handleScroll);
    return () => scrollContainer?.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <VerificationNotice />
      <div className="min-h-screen flex flex-col bg-black">
        <Navbar isScrolled={isScrolled2} currentPageSlug={props.currentPageSlug} />
        {/* <div className={`w-full bg-black transition-all duration-[600ms] ${isScrolled ? 'h-[200px]' : 'h-[0vh]'}`}></div> */}
        <div id='TSO-scroll-container' className={`relative rounded-t-[50px] overflow-scroll h-[100vh] transition-all duration-[600ms] ${isScrolled
          ? 'mt-[80px]'
          : 'mt-0'
          }`}>
          <main className="flex-grow">
            {props.children} {/* This is where the page content will be rendered */}
          </main>
          <Footer />
        </div>
        <ToastContainer theme="dark" pauseOnHover newestOnTop pauseOnFocusLoss />
      </div>
    </>
  );
}

export default Layout;



//Theme to affect the navbar
const theme = [
  {
    range: [0, 40], // From 0px to 40px scroll
    background: 'bg-transparent', // Tailwind class for transparent background
    text: 'text-gray-700', // Text color
  },
  {
    range: [41, 300], // From 41px to 300px scroll
    background: 'bg-purple-800', // Dark purple background
    text: 'text-white', // White text color
  },
  {
    range: [301, Infinity], // From 301px onward
    background: 'bg-white', // White background
    text: 'text-black', // Black text color
  },
];